import { ApolloClient } from 'apollo-client';
import { InMemoryCache, IntrospectionFragmentMatcher, defaultDataIdFromObject } from 'apollo-cache-inmemory';
// import { persistCache } from 'apollo-cache-persist';
import { HttpLink } from 'apollo-link-http';
import { ApolloLink, concat } from 'apollo-link';
// import { WebSocketLink } from 'apollo-link-ws';
// import { getMainDefinition } from 'apollo-utilities';
// import { Cache } from './cache';
import { tokenService } from '@withjoy/web-core';

const schema = require('./schema.json');

const types = schema.data.__schema.types.filter((type: any) => {
  return type.kind === 'UNION' || type.kind === 'INTERFACE';
});

// const getFetch = () => {
//   if (typeof window === 'undefined') {
//     const fetch = require('node-fetch');
//     console.log('node-fetch');
//     console.log(fetch);
//     return fetch;
//   } else {
//     return undefined;
//   }
// }

const getUri = (joyEnv: Window['joyEnv']) => {
  if (joyEnv && joyEnv.JOY_CONFIG_BLISS_SERVICE_HOSTNAME) {
    return `${joyEnv.JOY_CONFIG_BLISS_SERVICE_PROTOCOL}://${joyEnv.JOY_CONFIG_BLISS_GATEWAY_HOSTNAME}:${
      joyEnv.JOY_CONFIG_BLISS_SERVICE_PORT
    }/graphql`;
  } else {
    return `${process.env.API}/graphql`;
  }
};

const httpLink = new HttpLink({
  uri: getUri(window.joyEnv)
  // uri: `http://localhost:8080/graphql`
  // fetch: getFetch()
});

// const wsLink = new WebSocketLink({
//   uri: `ws://localhost:8080/graphql`,
//   options: {
//     reconnect: true,
//     connectionParams: {
//       authorization: tokenService.getToken() || ''
//   },
//   }
// });

// const link = split(({ query }) => {
//     const def = getMainDefinition(query);
//     return def.kind === 'OperationDefinition' && def.operation === 'subscription';
//   },
//   httpLink
// );

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext({
    headers: {
      authorization: tokenService.getToken() || ''
    }
  });

  return forward!(operation);
});

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: { __schema: { types } }
});

const cache = new InMemoryCache({
  fragmentMatcher,
  dataIdFromObject: (object: any) => {
    // FIXME: workaround buggy apollo cache, dont cache certain types at all!
    // https://github.com/apollographql/apollo-client/issues/3234
    switch (object.__typename) {
      case 'QuestionnaireWithAnswers':
        return defaultDataIdFromObject(object) + Math.random().toString();
      case 'TextQuestionWithAnswer':
        return defaultDataIdFromObject(object) + Math.random().toString();
      case 'RadioQuestionWithAnswer':
        return defaultDataIdFromObject(object) + Math.random().toString();
      case 'CheckboxQuestionWithAnswer':
        return defaultDataIdFromObject(object) + Math.random().toString();
      default:
        return defaultDataIdFromObject(object);
    }
  }
});

// persistCache({
//   cache,

// });

export const client = new ApolloClient({
  connectToDevTools: true,
  ssrMode: true,
  link: concat(authMiddleware, httpLink),
  cache
});
